module.exports = __webpack_public_path__ + "static/template_options_12_months-fa64b34e0dd9c8b85fe873d7ca80bd5b.png";